<template>
  <div
    class="home_layout"
  >
    <router-view />
  </div>
  <BottomAppBar v-if="!hideNavBar" />
</template>

<script setup>
import {computed} from 'vue'
import BottomAppBar from '@product/components/BottomAppBar/BottomAppBar.vue'
import store from '@/store/store.js'

const hideNavBar = computed(() => store.state.app.hideNavBar)
</script>

<style lang="scss" scoped>
.home_layout {
  overflow: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
</style>
